<template lang="pug">
div
  el-collapse(
    v-model='abaAtiva'
    )
    el-collapse-item(name='0')
      template(slot="title")
        h3 Listagem de Beneficiários
      informacoes-beneficiarios(
        v-if="dadosCadastro && dadosCadastro.dados && dadosCadastro.dados.cadastro"
        :beneficiarios="beneficiariosLista"
        :cadastroOriginal="dadosCadastro.dados.cadastro"
        :canRemove="true"
        @updateBeneficiariosLista="updateBeneficiariosLista"
      )
        template(slot="button-adicionar")
          span(style="color: red;") Obs: Lista de beneficiários só será modificada ao salvar ou finalizar análise da OS.
          .botaoAddMembros.pull-right
            app-button(
              v-if="!isAdicionandoBeneficiario"
              titulo="Adicionar Beneficiário",
              tipo="success",
              icone="plus-circle",
              method="novoBeneficiario",
              @novoBeneficiario="novoBeneficiario"
            )
    el-collapse-item(name='1', v-if="isAdicionandoBeneficiario")
      template(slot="title")
        .titulo {{ isEditar ? 'Editar Beneficiário' : 'Adicionar Beneficiário' }}
      app-pessoa-fisica(
        :pessoa='beneficiario.pessoa'
        :conjuge="beneficiario.conjuge.pessoa"
        :isBeneficiarioTeq="true"
        nomeAba='Beneficiário'
        :observer="observer"
        )
      app-documentos(
        aba="Beneficiário"
        :maxSize='25000',
        :valid-extensions="['png','jpg','jpeg','pdf','doc','docx']",
        :observer="observer"
        :tiposDocumentos="getDocumentos"
        :tiposDocumentosObrigatorios="[]"
        :removeOutros="true"
        :documentos="beneficiario.documentos"
      )
      .buttons
        app-button.botao(
          titulo="Cancelar",
          tipo="default",
          size="medium",
          icone="times-circle",
          method="disableAdicionar",
          @disableAdicionar="disableAdicionar"
        )
        app-button.botao(
          :titulo="getTitulo()",
          tipo="success",
          size="medium",
          icone="plus-circle",
          method="adicionar",
          @adicionar="adicionar"
        )
</template>

<script>
import * as _ from 'lodash'
import { mapActions } from 'vuex'
import AppActionButton from '@/components/AppActionButton.vue'
import AppButton from '@/components/AppButton.vue'
import AppDivider from '@/components/AppDivider.vue'
import AppLabel from '@/components/AppLabel.vue'
import AppQualificacao from './components/AppQualificacao.vue'
import AppDocumentos from '@/screens/central/components/cadastro/AppDocumentos.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao.vue'
import AppPaginacao from '@/components/AppPaginacao.vue'
import AppPessoaFisica from '@/components/AppPessoaFisica.vue'
import InformacoesBeneficiarios from '@/components/informacoesCadastro/InformacoesBeneficiarios.vue'

const PESSOA_FISICA = {
  _include: ['municipio'],
  apelido: '',
  cpf: '',
  dataNascimento: '',
  nome: '',
  rg: '',
  nomeDaMae: '',
  estadoCivil: '',
  descEstadoCivil: '',
  nacionalidade: '',
  naturalidade: '', // guarda o id do municipio
  orgaoExpedidor: {
    nome: '',
    codigo: '',
    id: '',
    estado: ''
  },
  municipio: {
    nome: '',
    estadoCod: '',
    id: ''
  }
}

const BENEFICIARIO_EMPTY = {
  _id: '',
  _include: ['pessoa', 'conjuge.pessoa', 'documentos'],
  documentos: [],
  pessoa: {
    _id: '',
    _include: ['pessoaFisica'],
    isPessoaFisica: true,
    pessoaFisica: _.cloneDeep(PESSOA_FISICA)
  },
  idPessoa: '',
  idsDocumentos: [],
  conjuge: {
    pessoa: {
      isPessoaFisica: true,
      pessoaFisica: _.cloneDeep(PESSOA_FISICA)
    }
  }
}

export default {
  mixins: [AppNotificacao],

  components: {
    AppActionButton,
    AppButton,
    AppDivider,
    AppLabel,
    AppQualificacao,
    AppDocumentos,
    AppPaginacao,
    AppPessoaFisica,
    InformacoesBeneficiarios
  },

  props: {
    processo: {
      required: true,
      type: Object
    },
    modulo: {
      type: String,
      required: true
    },
    scope: {
      type: String,
      required: true
    },
    observer: {
      type: Object
    }
  },

  data () {
    return {
      isAdicionandoBeneficiario: false,
      abaAtiva: '0',
      validOptions: ['UNIAO_ESTAVEL', 'UNIAO_HOMOAFETIVA', 'CASADO', 'VIUVO'],
      isEditar: false,
      cpfExistente: false,
      indexBeneficiario: -1,
      beneficiariosLista: [],
      beneficiario: _.cloneDeep(BENEFICIARIO_EMPTY),
      dadosCadastro: {}
    }
  },

  computed: {
    getDocumentos () {
      let documentos = this.tiposDocumentos.filter(
        tipoDocumento =>
          tipoDocumento.codigo === 'CPF_BENEFICIARIO' ||
          tipoDocumento.codigo === 'COMPROVANTE_RESIDENCIA_BENEFICIARIO' ||
          tipoDocumento.codigo === 'IDENTIFICACAO_BENEFICIARIO' ||
          tipoDocumento.codigo === 'OUTROS_BENEFICIARIO'
      )
      if (
        this.beneficiario.pessoa.pessoaFisica.estadoCivil === 'CASADO' ||
        this.beneficiario.pessoa.pessoaFisica.estadoCivil === 'UNIAO_ESTAVEL' ||
        this.beneficiario.pessoa.pessoaFisica.estadoCivil ===
          'UNIAO_HOMOAFETIVA'
      ) {
        documentos = [
          ...documentos,
          ...this.tiposDocumentos.filter(
            tipoDocumento =>
              tipoDocumento.codigo === 'IDENTIFICACAO_CONJUGE_BENEFICIARIO' ||
              tipoDocumento.codigo === 'CPF_CONJUGE_BENEFICIARIO'
          )
        ]
        if (this.beneficiario.pessoa.pessoaFisica.estadoCivil === 'CASADO') {
          documentos = [
            ...documentos,
            ...this.tiposDocumentos.filter(
              tipoDocumento =>
                tipoDocumento.codigo === 'CERTIDAO_CASAMENTO_BENEFICIARIO'
            )
          ]
        }
        if (
          this.beneficiario.pessoa.pessoaFisica.estadoCivil ===
            'UNIAO_ESTAVEL' ||
          this.beneficiario.pessoa.pessoaFisica.estadoCivil ===
            'UNIAO_HOMOAFETIVA'
        ) {
          documentos = [
            ...documentos,
            ...this.tiposDocumentos.filter(
              tipoDocumento =>
                tipoDocumento.codigo === 'UNIAO_HOMOAFETIVA_BENEFICIARIO'
            )
          ]
        }
      }
      if (
        this.beneficiario.pessoa.pessoaFisica.estadoCivil === 'VIUVO' &&
        this.beneficiario.conjuge.pessoa.pessoaFisica.temCertidaoObito
      ) {
        documentos = [
          ...documentos,
          ...this.tiposDocumentos.filter(
            tipoDocumento => tipoDocumento.codigo === 'ATESTADO_OBITO_CONJUGE'
          )
        ]
      }
      return documentos
    }
  },

  async created () {
    const response = await this.getProcessoWithCadastro(
      this.processo.numeroProtocolo
    )
    this.dadosCadastro = response.dadosCadastro
    this.beneficiariosLista =
      response.dadosCadastro.dados.cadastro.beneficiarios
    this.tiposDocumentos = await this.findDocumentos('beneficiario')
  },

  methods: {
    ...mapActions({
      getProcessoWithCadastro: 'processos/getProcessoByProtocolo',
      findDocumentos: 'tipoDocumento/findTiposDocumento',
      validateBeneficiario: 'cadastro/validateBeneficiario'
    }),

    getTitulo () {
      return this.isEditar ? 'Atualizar' : 'Adicionar'
    },

    getFieldName (fieldName) {
      return `${this.scope}.${fieldName}`
    },

    disableAdicionar () {
      this.limparBeneficiarioDados()
      this.cpfExistente = false
      this.isAdicionandoBeneficiario = false
      this.abaAtiva = '0'
    },

    async enableAdicionar () {
      this.isAdicionandoBeneficiario = true
      this.abaAtiva = '1'
    },

    async adicionar () {
      delete this.observer.refs['Administrativo/Documentos']
      const validations = await Promise.all(
        [
          this.observer.validate(),
          this.validateBeneficiario({
            cpfBeneficiario: this.beneficiario.pessoa.pessoaFisica.cpf,
            cpfConjuge: this.beneficiario.conjuge.pessoa.pessoaFisica.cpf
          })
        ]
      )
      validations.push(this.beneficiario.pessoa.pessoaFisica.cpf !== this.beneficiario.conjuge.pessoa.pessoaFisica.cpf)
      if (validations.some(valid => !valid)) {
        if (!validations[1]) {
          this.observer.errors['Beneficiário/CPF'].push('Cpf já cadastrado no sistema.')
        }
        if (!validations[2]) {
          this.observer.errors['Beneficiário/CPF'].push('Cpfs do beneficiário e conjuge não podem ser iguais.')
          this.observer.errors['Beneficiário/Conjuge - CPF'].push('Cpfs do beneficiário e conjuge não podem ser iguais.')
        }
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.VERIFICAR_CAMPOS
        )
        return
      }

      this.setInfosBeneficiariosOFF()

      const auxBeneficiariosLista = [...this.beneficiariosLista]
      auxBeneficiariosLista.push(this.beneficiario)

      this.updateBeneficiariosLista(auxBeneficiariosLista)
      this.disableAdicionar()
    },

    novoBeneficiario () {
      this.isEditar = false
      this.enableAdicionar()
    },
    /* TODO consertar estrutura de dados do beneficiario (OFF e Online) para um padrão para se utilizar no AppPessoaFisica */
    async editar (beneficiarioEditar, indexEditar) {
      this.limparBeneficiarioDados()
      this.beneficiario.pessoa.pessoaFisica.naturalidade = {
        ...this.beneficiariosLista[indexEditar].pessoa.pessoaFisica.municipio,
        codigoEstado: this.beneficiariosLista[indexEditar].pessoa.pessoaFisica
          .municipio.estadoCod
      }

      this.beneficiario.pessoa.pessoaFisica.ufNaturalidade =
        this.beneficiariosLista[indexEditar].pessoa.pessoaFisica
          .ufNaturalidade ||
        this.beneficiariosLista[indexEditar].pessoa.pessoaFisica.municipio
          .estadoCod

      this.beneficiario.documentos = [
        ...this.beneficiariosLista[indexEditar].documentos.map(documento => ({
          ...documento,
          tipoDocumento: { ...documento.tipo, descricao: documento.tipo.nome }
        }))
      ]
      this.isEditar = true
      this.enableAdicionar()
    },

    limparBeneficiarioDados () {
      this.beneficiario = _.cloneDeep(BENEFICIARIO_EMPTY)
    },

    toTitleCase (str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
      })
    },

    setInfosBeneficiariosOFF () {
      this.beneficiario.documentos.forEach((documento, index) => {
        Object.defineProperty(
          this.beneficiario.documentos[index],
          'tipo',
          Object.getOwnPropertyDescriptor(
            this.beneficiario.documentos[index],
            'tipoDocumento'
          )
        )
        this.beneficiario.documentos[index].tipo.caminhoPasta = this.beneficiario.documentos[index].tipo.codigo.toLowerCase()
        this.beneficiario.documentos[index].tipo.modulo = 'BENEFICIARIOS'
        this.beneficiario.documentos[index].tipo.nome = this.beneficiario.documentos[index].tipo.descricao
        delete this.beneficiario.documentos[index].tipoDocumento
        delete this.beneficiario.documentos[index].tipo.descricao
      })

      if (this.beneficiario.pessoa.pessoaFisica.nacionalidade === 'BR') {
        this.beneficiario.pessoa.pessoaFisica.municipio = {
          nome: this.beneficiario.pessoa.pessoaFisica.naturalidade.nome,
          estadoCod: this.beneficiario.pessoa.pessoaFisica.naturalidade
            .codigoEstado,
          id: this.beneficiario.pessoa.pessoaFisica.naturalidade.id
        }

        this.beneficiario.pessoa.pessoaFisica.naturalidade = {
          municipio: {
            id: this.beneficiario.pessoa.pessoaFisica.naturalidade.id
          }
        }
      }

      this.beneficiario.pessoa.pessoaFisica.descEstadoCivil = this.toTitleCase(
        this.beneficiario.pessoa.pessoaFisica.estadoCivil
      )
      this.beneficiario.pessoa.pessoaFisica.dataNascimento = Date.parse(
        this.beneficiario.pessoa.pessoaFisica.dataNascimento
      )
    },

    updateBeneficiariosLista (newBeneficiariosLista) {
      this.beneficiariosLista = [...newBeneficiariosLista]
      this.$emit('updateBeneficiariosLista', newBeneficiariosLista)
      this.$emit('changedBeneficiarios')
    }
  },

  watch: {
    isAdicionandoBeneficiario: {
      async handler (val) {
        this.tiposDocumentos = await this.findDocumentos('beneficiario')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.titulo {
  font-weight: bold;
}

.buttons {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
}

.pull-right {
  display: flex;
  justify-content: flex-end;
}

.botaoAddMembros {
  margin-bottom: 10px;
}

.erro {
  padding: 3px;
}

>>> .el-collapse-item__content {
  line-height: normal;
}

>>> .el-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

>>> .el-row .conjuge .el-row {
  margin-left: -15px !important;
  margin-right: -15px !important;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/Beneficiarios.vue